import { Link, useLocation, useParams } from 'react-router-dom';
import { MODULES } from '@/config/modules.config';
import { useI18n } from '@/i18n';

/**
 * Derived entirely from the current route + MODULES — no page passes its
 * own breadcrumb trail in manually. A detail route (/creators/:id) adds
 * one extra crumb showing the :id param.
 */
export function Breadcrumbs() {
  const { t } = useI18n();
  const location = useLocation();
  const params = useParams();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const moduleSeg = segments[0];
  const module = MODULES.find((m) => m.route === `/${moduleSeg}`);
  const idSeg = segments[1];

  return (
    <nav className="breadcrumbs">
      <Link to="/">{t('breadcrumbs.home')}</Link>
      {module && (
        <>
          <span className="crumb-sep">/</span>
          {idSeg ? <Link to={module.route}>{t(module.labelKey)}</Link> : <span>{t(module.labelKey)}</span>}
        </>
      )}
      {idSeg && (
        <>
          <span className="crumb-sep">/</span>
          <span>{params.id ?? idSeg}</span>
        </>
      )}
    </nav>
  );
}
